import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IFFShipmentSummaryResponse } from 'src/app/shared/common-components/common-structure';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-iff-detail-header',
    templateUrl: './iff-detail-header.component.html',
    styleUrls: ['./iff-detail-header.component.css'],
    standalone: false
})
export class IffDetailHeaderComponent implements OnInit {

  @Input() isFRTShipment = false;
  @Input() selectedIFFShipmentSummary$: Observable<IFFShipmentSummaryResponse>;
  @Output() exportClicked = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onExport() {
    this.exportClicked.emit();
  }

  getPassThruAmountHeader() {
    return this.isFRTShipment ? 'Fuel Surcharge Cost' : 'Pass Thru Amount';
  }

}
